<div class="hf-plans-details-wrapper">
  <div class="content">
    <div class="item" *ngFor="let item of plans">
      <div class="title-wrapper">
        <span [innerHTML]="item.title" class="hf-heading"></span>
        <span *ngIf="item.title.includes('illness')" class="info-icon">ⓘ</span>
      </div>
      <ng-container *ngFor="let item1 of item.offers">
        <span [innerHTML]="item1.title" class="subheading"></span>
      </ng-container>
    </div>
  </div>
  <div class="essential-plan">
    <div class="plan-title">
      Essentials 
    </div>
    <div class="plan-content" [ngClass]="{'card-selected': recommended === 'essentials'}">
      <div class="recommended-plans" *ngIf="recommended === 'essentials'">
        Recommended Plan For You
      </div>
      <div class="item" [ngClass]="{
          'mt-19': i === 0 && recommended === 'essentials', 
          'mt-75': i === 0 && recommended !== 'essentials',
          'mt-60': i === 1 || i === 5 && screenWidth > 1280  || screenWidth > 1280 && i === 4 || i === 4 && screenWidth <= 1280,
          'mt-65': i === 2 || i === 5 && screenWidth <= 1280,
          'mt-95': screenWidth > 1280 && i == 3,
          'mt-70': i === 3 || i === 4,
          'mt-90': i === 6
        }"  *ngFor="let item of plans; index as i">
        <ng-container *ngFor="let item1 of item.offers">
          <span class="plan-item" *ngIf="item1.essentials_yearly !== 'yes' && item1.essentials_yearly !=='no' && item1.essentials_yearly !== 'OPTIONAL'">
            {{item1.essentials_yearly}}
          </span>
          <mat-icon *ngIf="item1.essentials_yearly === 'yes'">check</mat-icon>
          <mat-icon class="close" *ngIf="item1.essentials_yearly === 'no'">close</mat-icon>
          <span class="optional-wrapper" *ngIf="item1.essentials_yearly === 'OPTIONAL'">
            Optional
          </span>
        </ng-container>
      </div>
      <div class="horizontal-rule"></div>
      <div class="plan-amount-wrapper">
        <div class="plan-price-title">
          <div class="text">
            Plan Price
          </div>
        </div>
        <div class="amount-wrapper">
          <div class="amount">
            {{amountData?.essentials?.yearly?.amount | currency: 'INR' : 'symbol' : '1.0-0' }}
          </div>
          <div class="duration">
            /yearly
          </div>
        </div>
        <div class="striked-price">
          {{amountData?.essentials?.yearly?.plan_price | currency: 'INR':'symbol':'1.0-0'}}
        </div>
      </div>
      <div class="buy-now-btn">
        <app-button label="Buy Now" btnClass="hf-primary-btn" (btnClick)="onPlanBuy('essentials')"></app-button>
      </div>
    </div>
  </div>
  <div class="plus-plan">
    <div class="plan-title">
      Plus
    </div>
    <div class="plan-content" [ngClass]="{' card-selected': recommended === 'plus'}">
      <div class="recommended-plans" *ngIf="recommended === 'plus'">
        Recommended Plan For You
      </div>
      <div class="item" [ngClass]="{
          'mt-19': i === 0 && recommended === 'plus', 
          'mt-75': i === 0 && recommended !== 'plus',
          'mt-60': i === 1 || i === 5 && screenWidth > 1280 || screenWidth > 1280 && i === 4 || i === 4 && screenWidth <= 1280,
          'mt-65': i === 2 || i === 5 && screenWidth <= 1280,
          'mt-95': screenWidth > 1280 && i == 3,
          'mt-70': i === 3 || i === 4,
          'mt-90': i === 6
        }" *ngFor="let item of plans; index as i">
        <ng-container *ngFor="let item1 of item.offers">
          <span class="plan-item" *ngIf="item1.plus_yearly !== 'yes' && item1.plus_yearly !=='no' && item1.plus_yearly !== 'OPTIONAL'">
            {{item1.plus_yearly}}
          </span>
          <mat-icon *ngIf="item1.plus_yearly === 'yes'">check</mat-icon>
          <mat-icon class="close" *ngIf="item1.plus_yearly === 'no'">close</mat-icon>
          <span class="optional-wrapper" *ngIf="item1.plus_yearly === 'OPTIONAL'">
            Optional
          </span>
        </ng-container>
      </div>
      <div class="horizontal-rule"></div>
      <div class="plan-amount-wrapper">
        <div class="plan-price-title">
          <div class="text">
            Plan Price
          </div>
          <div class="limited-offer">
            LIMITED OFFER
          </div>
        </div>
        <div class="amount-wrapper">
          <div class="amount">
            {{amountData?.plus?.yearly?.amount| currency: 'INR' : 'symbol' : '1.0-0' }}
          </div>
          <div class="duration">
            /yearly
          </div>
        </div>
        <div class="striked-price">
          {{amountData?.plus?.yearly?.plan_price | currency: 'INR':'symbol':'1.0-0'}}
        </div>
      </div>
      <div class="buy-now-btn">
        <app-button label="Buy Now" btnClass="hf-primary-btn" (btnClick)="onPlanBuy('plus')"></app-button>
      </div>
    </div>
  </div>
</div>